import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Card, Spinner } from "react-bootstrap";
import { FiSearch, FiEdit3, FiTrash2, FiLink, FiFileText } from "react-icons/fi";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { Datacontext } from "../../context/Datacontext";
import { useContext } from "react";
import "./blogs.css"

export function AdminBlogs() {
  const { blogs, setBlogs } = useContext(Datacontext);
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [show, setShow] = useState(false);
  const [editing, setEditing] = useState(null);
  const [showLinkInput, setShowLinkInput] = useState(false);
  const [hasContent,setHasContent]=useState(false)
  const [submitting, setSubmitting] = useState(false);

  const [form, setForm] = useState({
    title: "",
    category: "",
    image: null,
    link: "",
    currentImage: "",
      isPublished: true, // default: checked (visible to public)

  });

  // Fetch blogs
  const fetchBlogs = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/blogs`);
      const data = await res.json();

      const list = Array.isArray(data) ? data : data.data || [];
      setBlogs(list);
      setFilteredBlogs(list);
    } catch (error) {
      console.error("Error fetching blogs:", error);
      toast.error("Failed to load blogs");
      setBlogs([]);
      setFilteredBlogs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Search functionality
  useEffect(() => {
    const term = searchTerm.toLowerCase();
    const filtered = blogs.filter(
      (blog) =>
        (blog.title || "").toLowerCase().includes(term) ||
        (blog.category || "").toLowerCase().includes(term)
    );
    setFilteredBlogs(filtered);
  }, [searchTerm, blogs]);

  const handleClose = () => {
    setShow(false);
    setEditing(null);
    setShowLinkInput(false);
    setForm({
      title: "",
      category: "",
      image: null,
      link: "",
      currentImage: "",
      isPublished: true, // default: checked (visible to public)

    });
  };

  const handleShow = () => setShow(true);

// const handleSubmit = async (e) => {
//       const token = localStorage.getItem("MagazineToken")

//     e.preventDefault();

//     if (!form.title || !form.category || (!form.image && !form.currentImage)) {
//       toast.error("Title, Category, and Image are required");
//       return;
//     }

//     const data = new FormData();
//     data.append("title", form.title);
//     data.append("category", form.category);
//     if (form.image) data.append("coverImage", form.image);
//     data.append("isPublished", form.isPublished );
//     if (showLinkInput && form.link) data.append("link", form.link);

//     const url = editing
//       ? `${process.env.REACT_APP_BACKEND_URL}/api/blogs/edit/${editing}`
//       :`${process.env.REACT_APP_BACKEND_URL}/api/blogs/add`;

//     const method = editing ? "PUT" : "POST";

//     try {
//       const res = await fetch(url, { method,    headers: {
//         Authorization: `Bearer ${token}`,
//         // Do NOT set Content-Type → browser sets correct boundary
//       }, body: data });
//       if (!res.ok) {
//         const err = await res.text();
//         throw new Error(err || "Operation failed");
//       }

//       toast.success(editing ? "Blog updated successfully!" : "Blog added successfully!");
//       fetchBlogs();
//       handleClose();
//     } catch (err) {
//       toast.error("Error: " + err.message);
//     }
//   };
const handleSubmit = async (e) => {
  e.preventDefault();
  if (submitting) return; // prevent double click

  const token = localStorage.getItem("MagazineToken");

  if (!form.title || !form.category || (!form.image && !form.currentImage)) {
    toast.error("Title, Category, and Image are required");
    return;
  }

  setSubmitting(true); // 🔥 START LOADING

  const data = new FormData();
  data.append("title", form.title);
  data.append("category", form.category);
  data.append("isPublished", form.isPublished);

  if (form.image) data.append("coverImage", form.image);
  if (showLinkInput && form.link) data.append("link", form.link);

  const url = editing
    ? `${process.env.REACT_APP_BACKEND_URL}/api/blogs/edit/${editing}`
    : `${process.env.REACT_APP_BACKEND_URL}/api/blogs/add`;

  const method = editing ? "PUT" : "POST";

  try {
    const res = await fetch(url, {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    });

    if (!res.ok) {
      const err = await res.text();
      throw new Error(err || "Operation failed");
    }

    toast.success(editing ? "Blog updated successfully!" : "Blog added successfully!");
    fetchBlogs();
    handleClose();
  } catch (err) {
    toast.error("Error: " + err.message);
  } finally {
    setSubmitting(false); // 🔥 STOP LOADING
  }
};

  
const editBlog = (blog) => {
    setEditing(blog.id);
    setShowLinkInput(!!blog.link);
    setHasContent(!!blog.content)
    setForm({
      title: blog.title,
      category: blog.category,
      image: null,
      link: blog.link || "",
      currentImage: blog.cover_image,
      isPublished: blog.is_published === 1 || blog.is_published === true,
    });
    setShow(true);
  };

  const deleteBlog = async (id) => {
        const token = localStorage.getItem("MagazineToken")


    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/blogs/delete/${id}`, {
        method: "DELETE",    headers: {
        Authorization: `Bearer ${token}`,
        // Do NOT set Content-Type → browser sets correct boundary
      },
      });

      if (!res.ok) throw new Error("Failed to delete");

      toast.success("Blog deleted successfully!");
      fetchBlogs();
    } catch (err) {
      toast.error("Failed to delete blog");
    }
  };

  return (
    <div className="container  admin-blogs-root">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold text-dark page-title">Blogs</h2>

        {/* Floating Add Button */}
        <button
          onClick={handleShow}
          className="floating-add-btn"
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.08)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          +
        </button>
      </div>

      {/* Search Bar */}
      <div className="input-group mb-4 search-wrapper" style={{ maxWidth: "400px" }}>
        <span className="input-group-text bg-white border-end-0">
          <FiSearch className="text-muted" />
        </span>
        <input
          type="text"
          className="form-control border-start-0 ps-0 search-input"
          placeholder="Search by title or category..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Loading or Empty State */}
      {loading ? (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "80vh" }}>
          <Spinner animation="border" variant="primary" style={{ width: "2rem", height: "2rem" }} />
          <h5 className="mt-4 text-muted">Loading blogs...</h5>
        </div>
      ) : filteredBlogs.length === 0 ? (
        <div className="text-center py-5">
          <h4 className="text-muted">
            {searchTerm ? "No blogs found matching your search" : "No blogs yet"}
          </h4>
          {!searchTerm && (
            <p className="text-muted">Click the + button to add your first blog!</p>
          )}
        </div>
      ) : (
        <Row className="custom-row-gap">
          {filteredBlogs.map((blog) => (
 <Col xl={3} sm={6} md={8} lg={4} key={blog.id}>              <div className="card-wrapper">
                <Card className="blog-card shadow-lg">
                  <div className="card-image-wrapper">
                    <img
          src={`${process.env.REACT_APP_BACKEND_URL}${blog.cover_image}`}
                      alt={blog.title}
                      className="card-image"
                      onError={(e)=>{ e.currentTarget.src = "/placeholder-image.png" }}
                    />
                      {/* Show badge ONLY if blog is unpublished */}
  {!blog.is_published && (
    <span className="blog-status-badge draft">
      Unpublished
    </span>)}
                  </div>

                  <Card.Body className="card-body-flex">
                    <div className="card-meta">
                      <h5 className="fw-bold blog-title">{blog.title}</h5>
                      <p className="text-muted small mb-1 blog-category">{blog.category}</p>
                      <p className="text-muted small blog-date">
                        {blog.created_at && format(new Date(blog.created_at), "dd MMM yyyy")}
                      </p>
                    </div>

                    <div className="card-actions">
                      <Button
                        onClick={() => editBlog(blog)}
                        className="btn-edit d-flex align-items-center gap-2"
                      >
                        <FiEdit3 size={18} />
                        Edit
                      </Button>

                      <Button
                        variant="light"
                        onClick={() => deleteBlog(blog.id)}
                        className="btn-delete d-flex align-items-center gap-2"
                      >
                        <FiTrash2 size={18} />
                        Delete
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          ))}
        </Row>
      )}

      {/* Add/Edit Modal */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{editing ? "Edit Blog" : "Add New Blog"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                required
                value={form.title}
                onChange={(e) => setForm({ ...form, title: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Category</Form.Label>
              <Form.Control
                type="text"
                required
                value={form.category}
                onChange={(e) => setForm({ ...form, category: e.target.value })}
                placeholder="e.g., Technology, Lifestyle, Health"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Blog Image</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e) => setForm({ ...form, image: e.target.files[0] || null })}
              />
              {form.currentImage && !form.image && (
                <div className="mt-2 text-success small">
                  Current: <strong>{form.currentImage.split("/").pop()}</strong>{" "}
                  (<a href={`${process.env.REACT_APP_BACKEND_URL}${form.currentImage}`} target="_blank" rel="noreferrer">View</a>)
                </div>
              )}
              {form.image && (
                <div className="mt-2 text-info small">
                  New: <strong>{form.image.name}</strong>
                </div>
              )}
            </Form.Group>

            {/* Action Buttons */}
           {!editing && <div className="d-flex gap-3 mb-3">
              <Button
                variant={showLinkInput ? "primary" : "outline-primary"}
                className="flex-fill d-flex align-items-center justify-content-center gap-2"
                onClick={() => setShowLinkInput(true)}
                type="button"
              >
                <FiLink size={18} />
                Add Link
              </Button>

             <Button
  variant="outline-secondary"
  className="flex-fill d-flex align-items-center justify-content-center gap-2"
  type="button"
  onClick={async () => {
    if (!form.title || !form.category || (!form.image && !form.currentImage)) {
      toast.error("Title, Category, and Image are required");
      return;
    }

    const data = new FormData();
    data.append("title", form.title);
    data.append("category", form.category);
    if (form.image) data.append("coverImage", form.image);
    if (showLinkInput && form.link) data.append("link", form.link);
    data.append("isPublished", form.isPublished );


    try {
      let url, method;

      // if (editing) {
      //   url = `${process.env.REACT_APP_BACKEND_URL}/api/blogs/edit/${editing}`;
      //   method = "PUT";
      // } else {
              const token = localStorage.getItem("MagazineToken")

        url = `${process.env.REACT_APP_BACKEND_URL}/api/blogs/add`;
        method = "POST";
      // }

      const res = await fetch(url, { method,  headers: {
        Authorization: `Bearer ${token}`,
        // Do NOT set Content-Type → browser sets correct boundary
      }, body: data });
      const response = await res.json();

      if (!res.ok) throw new Error(response.error || "Failed");

      const blogId = editing ? editing : response.id;

      handleClose();
      window.location.href = `/admin/write-blog/new/${blogId}`;

    } catch (err) {
      console.error(err);
      toast.error("Failed to save and redirect");
    }
  }}
>
  <FiFileText size={18} />
  Write Blog
</Button>


            </div>}

          {showLinkInput && (
  <Form.Group className="mb-3">
    <Form.Label>External Blog Link</Form.Label>
    <Form.Control
      type="url"
      placeholder="https://example.com/my-blog-post"
      value={form.link}
      onChange={(e) => setForm({ ...form, link: e.target.value })}
    />
  </Form.Group>
)}
            <Form.Group className="mb-3 d-flex align-items-center">
  <Form.Check
    type="checkbox"
    id="isPublished"
    label="Publish to main website (visible to all users)"
    checked={form.isPublished}
    onChange={(e) => setForm({ ...form, isPublished: e.target.checked })}
    className="me-2"
    style={{ fontSize: "1rem" }}
  />
</Form.Group>

{!hasContent &&<Button
  type="submit"
  disabled={submitting}
  className="w-100 mt-3 d-flex align-items-center justify-content-center"
  style={{
    background: "linear-gradient(90deg,#6d28d9,#4c1d95)",
    border: "none",
    opacity: submitting ? 0.8 : 1,
  }}
>
  {submitting ? (
    <>
      <Spinner
        animation="border"
        size="sm"
        className="me-2"
        style={{ width: "1rem", height: "1rem" }}
      />
      {editing ? "Updating..." : "Adding..."}
    </>
  ) : (
    editing ? "Update Blog" : "Add Blog"
  )}
</Button>}


{editing && hasContent && (
  <div className="d-flex gap-3 mb-3">
    <Button
      variant="primary"
      className="flex-fill"
      type="button"
onClick={async () => {
  if (submitting) return;
  setSubmitting(true);

  try {
    const token = localStorage.getItem("MagazineToken");

    const data = new FormData();
    data.append("title", form.title);
    data.append("category", form.category);
    data.append("isPublished", form.isPublished);

    if (form.image) data.append("coverImage", form.image);
    if (showLinkInput && form.link) data.append("link", form.link);

    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/blogs/edit/${editing}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: data,
      }
    );

    const response = await res.json();
    if (!res.ok) throw new Error(response.error || "Failed");

    toast.success("Fields updated successfully");
    handleClose();
  } catch (err) {
    toast.error("Update failed");
  } finally {
    setSubmitting(false);
  }
}}
    >
      Update Fields
    </Button>

    <Button
      variant="secondary"
      className="flex-fill"
      type="button"
  onClick={async () => {
  if (submitting) return;
  setSubmitting(true);

  try {
    if (!form.title || !form.category || (!form.image && !form.currentImage)) {
      toast.error("Title, Category, and Image are required");
      return;
    }

    const token = localStorage.getItem("MagazineToken");

    const data = new FormData();
    data.append("title", form.title);
    data.append("category", form.category);
    data.append("isPublished", form.isPublished);

    if (form.image) data.append("coverImage", form.image);
    if (showLinkInput && form.link) data.append("link", form.link);

    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/blogs/add`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: data,
      }
    );

    const response = await res.json();
    if (!res.ok) throw new Error(response.error || "Failed");

    const blogId = response.id;

    handleClose();
    window.location.href = `/admin/write-blog/new/${blogId}`;
  } catch (err) {
    console.error(err);
    toast.error("Failed to save and redirect");
  } finally {
    setSubmitting(false); // ✅ Always reset
  }
}}
    >
      Update Fields & Edit Content
    </Button>
  </div>
)}


          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}
